import Button from 'components/Button/Button';
import usePusherEvent from 'hooks/usePusherEvent';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { notifyCallInProgress } from 'store/modules/ivr/actions';
import { show10DLCBanner } from 'store/modules/modals/actions';
import { onNewNotification } from 'store/modules/notifications/actions';
import { getName } from 'utils';
import toast from 'utils/toast';

const NotificationListener = () => {
  const dispatch = useDispatch();
  const user = useSelector((s) => s.user.user);

  usePusherEvent('user', 'notification', (data) => {
    const { notifications_type } = data;
    const isBanner = notifications_type === '10dlc status change';
    if (isBanner) {
      return dispatch(show10DLCBanner(data));
    }
    const isCall = notifications_type === 'call_in_progress';
    if (isCall) {
      return dispatch(notifyCallInProgress(data));
    }
    dispatch(onNewNotification(data));
  });

  usePusherEvent('user', 'message', (data) => {
    if (user.user_display_incoming_sms_popup === '1') {
      const { message, contact, inbox_item } = data;
      if (window.location.href.includes(contact.hash)) return;
      const { msg_content } = message;
      toast.info({
        autoClose: 10000,
        title: getName(contact),
        message: msg_content,
        customButton: (
          <Button
            size="small"
            target="_blank"
            href={`/messages/inbox/${contact.hash}?inboxId=${inbox_item.inbox_id}`}
          >
            View Conversation
          </Button>
        ),
      });
    }
  });

  return null;
};

export default NotificationListener;
